import { useTranslation } from "react-i18next";
import ListGroup from "./controls/ListGroup";
import ListGroupObjectItem from "./controls/ListGroupObjectItem";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import PointValue from "./controls/PointValue";
import MeasureValue from "./controls/MeasureValue";
import LabeledValue from "./controls/LabeledValue";
import BooleanValue from "./controls/BooleanValue";

export function TomaAguaSuperficialList({ value, select, remove, disabled }) {
  const { t } = useTranslation();
  return (
    <ListGroup>
      {value.map((item, index) => (
        <ListGroupObjectItem
          key={item.orden}
          index={index}
          value={item}
          indexLabel={t("tomaAguaSuperficial.orden")}
          deletable
          onDelete={(event) => {
            event.preventDefault();
            remove(index);
          }}
          editable
          onEdit={(event) => {
            event.preventDefault();
            select(index);
            document.getElementById("tomasAguaSuperficial").scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
          }}
          disabled={disabled}
        >
          {({ value }) => (
            <Grid>
              <Row>
                <Col>
                  <PointValue
                    label={t("tomaAguaSuperficial.ubicacion")}
                    value={value.ubicacion}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <MeasureValue
                    label={t("tomaAguaSuperficial.caudalMedio")}
                    value={value.caudalMedio}
                  />
                </Col>
                <Col lg={4}>
                  <MeasureValue
                    label={t("tomaAguaSuperficial.caudalPico")}
                    value={value.caudalPico}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <LabeledValue
                    label={t("tomaAguaSuperficial.subcuenca")}
                    value={value.subcuenca}
                    labelAttr="nombre"
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <BooleanValue
                    label={t("tomaAguaSuperficial.caudalimetroFunciona")}
                    value={value.caudalimetroFunciona}
                  />
                </Col>
              </Row>
            </Grid>
          )}
        </ListGroupObjectItem>
      ))}
    </ListGroup>
  );
}
